/* eslint-disable @typescript-eslint/no-explicit-any */

export const useApi = () => {
  const { public: { apiUrl, apiKey } } = useRuntimeConfig()

  const fetch = $fetch.create({
    baseURL: apiUrl,
    query: {
      key: apiKey
    }
  })

  const fetchAll = async <T = any>(path: string, query: Record<string, any> = { page: 1, page_size: 10 }) => {
    return fetch<T>(`${path}`, { query })
  }

  const fetchById = async <T = any>(path: string, id: string) => {
    return await fetch<T>(`${path}/${id}`)
  }

  const create = async <T = any>(path: string, data: Record<string, any>) => {
    return await fetch<T>(`${path}`, {
      method: 'POST',
      body: data
    })
  }

  const update = async <T = any>(path: string, id: string, data: Record<string, any>) => {
    return await fetch<T>(`${path}/${id}`, {
      method: 'PUT',
      body: data
    })
  }

  const destroy = async <T = any>(path: string, id: string) => {
    return await fetch<T>(`${path}/${id}`, {
      method: 'DELETE'
    })
  }

  return {
    fetchAll,
    fetchById,
    create,
    update,
    destroy
  }
}
